module.exports = __webpack_public_path__ + "img/bag.3fe33b59.svg";